import { css } from '../../../styled-components';
export const migrosAppStyles = css`
  font-weight: ${({
  theme: {
    fonts
  }
}) => fonts.weights.regular};
  font-size: ${({
  theme: {
    fonts
  }
}) => fonts.sizes.text.small};
  line-height: ${({
  theme: {
    fonts
  }
}) => fonts.sizes.text.small};

  color: ${({
  light,
  disabled,
  theme: {
    colors
  }
}) => !light ? colors.brand.textInverted[100] : disabled ? colors.tints.gray[75] : colors.brand.primary[100]};
  background-color: ${({
  light,
  disabled,
  theme: {
    colors
  }
}) => light ? colors.brand.textInverted[100] : disabled ? colors.tints.gray[75] : colors.brand.primary[100]};
  border: 1px solid;
  border-color: ${({
  disabled,
  theme: {
    colors
  }
}) => disabled ? colors.tints.gray[75] : colors.brand.primary[100]};
  border-radius: ${({
  theme: {
    borderRadiuses
  }
}) => borderRadiuses.small};
  box-sizing: border-box;
  cursor: default;
  display: inline-block;
  margin: 0;
  overflow: hidden;
  padding: 12px 16px;
  text-shadow: none;
  text-size-adjust: 100%;
  text-transform: none;
  user-select: none;
  width: 100%;
  text-align: left;
`;